<template>
  <div class="text-xs text-white-080" :class="displayedTextStyle">
    <span v-if="state.show === true">
      <div class="text-white-080 text-pre-line" v-if="text?.mainText">
        {{ text.mainText }}
      </div>
      <div
        class="text-whitebase font-bold mt-4 text-pre-line"
        v-if="text?.formulaText"
      >
        {{ text.formulaText }}
      </div>
      <div class="text-xs text-white-040 text-pre-line" v-if="text?.endText">
        {{ text.endText }}
      </div>
    </span>
    <span v-else>
      {{ displayedText }}
    </span>
    <span
      @click="state.show = !state.show"
      v-if="text?.mainText.length > 295"
      class="font-bold text-whitebase cursor-pointer"
    >
      &nbsp;{{ state.show === true ? 'See Less' : 'See More' }}</span
    >
  </div>
</template>
<script setup>
import { computed, reactive, watch } from 'vue';

const state = reactive({
  show: false,
});

const props = defineProps({
  text: String,
  displayedTextStyle: {
    type: String,
    default: 'py-2 px-4 mb-4 bg-white-040 rounded',
  },
  resetShow: Number,
});
const displayedText = computed(() => {
  if (props.text?.mainText.length > 295)
    return props.text.mainText.slice(0, 295) + '...';

  return props.text.mainText;
});

watch(
  () => props.resetShow,
  () => (state.show = false),
);
</script>
<style>
.text-pre-line {
  white-space: pre-line;
}
</style>
